import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'
import * as contentPageActions from 'reduxBits/contentfulPage/actions'
import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { globalData } from 'tracking/dataCollectors'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    ...gtm.clearDataLayerParameters(),
    ...globalData(state),
    ...{
      event: 'view', // trigger GTM tags
      eventType: 'View', // Begin with uppercase. Type of action for pulse.
      objectType: 'Page', // Begin with uppercase
      domain: 'content', // Technical domain. Ex. Adout
      subDomain: 'content', // Technical sub domain. Ex. list.
      objectId: 'content_page',
    },
    ...localData,
  })

const contentPageViewData = (currentPageEntry) => {
  if (currentPageEntry) {
    const pagePathName = document.location.pathname.replace(/\/+$/, '')
    const pageSearchName = document.location.search
    const pageId = pagePathName + pageSearchName
    return {
      subDomain: _.lowerCase(_.get(currentPageEntry, 'pageTemplate', 'article')),
      objectId: pageId,
      objectName: _.get(currentPageEntry, 'pageTitle'),
      origin: {
        id: pageId,
        type: 'Page',
        name: _.get(currentPageEntry, 'pageTitle'),
        url: encodeURI(window.location.href),
      },
    }
  }
  return {}
}

export const contentPageView = {
  validators: [validators.redux(contentPageActions.TRIGGER_CONTENT_PAGE_ANALYTICS)],
  events: [
    gtm.event(({ state }) => {
      return createDataLayerObject(state, {
        ...contentPageViewData(_.get(state, 'contentfulPage.data.contentPage')),
      })
    }),
  ],
}
